// extracted by mini-css-extract-plugin
export var container = "_7l-0";
export var icon = "_7l-1";
export var text = "_7l-2";